import { MaintenanceStage } from "@/core/api/generated/v1";

export class MaintenanceHelper {
  public static humanizeMaintenanceStage(stage?: MaintenanceStage) {
    switch (stage) {
      case MaintenanceStage.None: {
        return "None";
      }
      case MaintenanceStage.Draft: {
        return "Draft";
      }
      case MaintenanceStage.InProgress: {
        return "In progress";
      }
      case MaintenanceStage.Completed: {
        return "Completed";
      }
      default: {
        return "-";
      }
    }
  }
}
